/*
 * Formats that can be sent through from dashboard to panel
	{
 		"params": {
 			"chart_name": "ERPAnalysisChartOne",
 			"title": "Monthly Revenue",
 			"use_filter": true,
			"use_dropdown": true,
 			"dropdown_filter_column": "order_type",
			"dropdown_params": { "cache": "Orders.OrderTypes", "cache_column": "name" }
			"url": "/charts/chart-view/"
		}
	},
	{
		"params": {
			"chart_name": "",
			"title": "Stock Item Count",
			"date_filter_column": "date_start",
			"use_filter": false,
			"use_date": true,
			"url": "/charts/chart-view/"
		}
	}
	
*/

import template from './chart-display-panel.html';

class ChartDisplayPanelViewModel
{
	constructor (params)
	{
		this.params = params;

		this.title = ko_helper.safe_observable(params.title);
		this.chart_name = ko_helper.safe_observable(params.chart_name || null);
		this.reload = ko.observable();

		//filters
		this.filter = ko.observable();
		this.use_filter = ko_helper.safe_observable(params.use_filter || false);
		
		//Date
		this.date_filter_column = ko.observable(params.date_filter_column);
		this.use_date = ko_helper.safe_observable(params.use_date || false);
		this.date_start = ko.observable(new moment().startOf('year').format('YYYY-MM-DD'));
		this.date_end = ko.observable(new moment().add(1, 'year').startOf('year').format('YYYY-MM-DD'));
		this.time_span_interval = ko.observable(1);
		this.time_span = ko.observable('day(s)');
		this.chart_height = ko_helper.safe_observable(params.chart_height || '450px');
		this.chart_width = ko_helper.safe_observable(params.chart_width || '800px');

		//Dropdown
		this.use_dropdown = ko_helper.safe_observable(params.use_dropdown || false);
		this.dropdown_filter_column = ko.observable(params.dropdown_filter_column);	
		this.selected_dropdown_value = ko_helper.safe_observable(params.selected_dropdown_value || '');
		this.dropdown_params = ko_helper.safe_observable(params.dropdown_params || '');
		this.dropdown_list = ko.observableArray();

		this.init();
	}

	reload_filters()
	{
		if(this.use_filter())
		{
			let filters = {filter: []};
			if(this.use_date())
			{
				filters.filter = [
					{'field': this.date_filter_column(), 'operator': '>=', 'value': this.date_start()},
					{'field': this.date_filter_column(), 'operator': '<', 'value': this.date_end()},
				];
				filters.filter_join = 'AND';
			}

			if(this.use_dropdown())
			{
				if (this.dropdown_params())
				{
					if(this.selected_dropdown_value() != '')
						filters.filter.push({'field': this.dropdown_filter_column(), 'operator': '=', 'value': this.selected_dropdown_value()});
				}
				else
				{
					console.error('Dropdown Params required');
				}
			}
			
			this.filter(filters);
		}
	}

	async init ()
	{
		if (this.dropdown_params() != '')
		{
			let cache = this.dropdown_params().cache;
			let cache_column = this.dropdown_params().cache_column;

			let result = await Grape.cache.fetch(cache);
			result = result.map(item => item[cache_column]);
			
			if(result)
			{
				this.selected_dropdown_value(result[0]);
				this.dropdown_list(result);
			}
		}

		this.reload_filters();
	}

}

export default {
	name: 'chart-display-panel',
	viewModel: ChartDisplayPanelViewModel,
	module_type: 'ko',
	template: template
}
